import { render } from "./TariffView.vue?vue&type=template&id=60f2d8d7"
import script from "./TariffView.vue?vue&type=script&lang=js"
export * from "./TariffView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__